"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Whatsapp = function Whatsapp(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation)
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 12.808c1.136.272 1.616-.34 1.796-.82.112-.296 0-.636-.296-.772l-.772-.388c-.272-.112-.568-.068-.752.16l-.16.184c-.16.184-.432.272-.66.184-1-.364-1.548-1.092-1.796-1.504a.677.677 0 01.024-.684l.16-.204c.112-.184.16-.432.068-.636l-.432-.956c-.16-.296-.524-.456-.82-.34-.524.252-1.136.752-.636 2.048.82 2.04 2.436 3.248 4.276 3.728z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.136 16.284a6.226 6.226 0 01-3.456-1.036l-2.384.448a.443.443 0 01-.424-.144.447.447 0 01-.1-.436l.696-2.412a6.289 6.289 0 015.676-8.988c3.464 0 6.276 2.82 6.276 6.284a6.29 6.29 0 01-6.284 6.284zM6.784 14.3c.096 0 .188.028.264.084A5.365 5.365 0 0015.496 10c0-2.956-2.4-5.36-5.36-5.36a5.363 5.363 0 00-4.768 7.808.475.475 0 01.032.34l-.536 1.868 1.836-.344a.304.304 0 01.084-.012z",
    fill: color
  }));
};
var _default = exports["default"] = Whatsapp;